module.exports = "https://static.wmbcdn.com/uniweb/images/138f34096e766c24b1e1672f962c44b5.svg";